import { CommonGenericModel } from '../common';
import { AssetVariable } from './asset-variable.model';
import { AssetStatusName } from './enums';

export enum AssetGroupControlNames {
  NAME = 'name',
  ERP_REFERENCE = 'erpReference',
  DESCRIPTION = 'description'
}

export enum AssetGroupStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export interface AssetGroupCreate {
  name: string;
  erpReference: string | null;
  description: string | null;
  siteId: string;
}

export interface AssetGroupTag {
  category: string;
  label: string;
}

export interface AssetGroupRelatedAsset {
  id: string;
  name: string;
  status: { name: AssetStatusName };
  priority: number;
  dispatch: { shipTo: string | null };
  product1: { name: string | null };
  product2: { name: string | null };
  variables?: AssetVariable[];
}

export interface AssetGroup extends CommonGenericModel {
  id: string;
  name: string;
  erpReference: string | null;
  description: string | null;
  status: AssetGroupStatus;
  hiddenAssetsCount: number;
  site: { id: string; name: string };
  entity: { id: string; name: string };
  assets: AssetGroupRelatedAsset[];
}
